import { render, staticRenderFns } from "./AddReceipt.vue?vue&type=template&id=20546e9a&scoped=true&"
import script from "./AddReceipt.vue?vue&type=script&lang=js&"
export * from "./AddReceipt.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20546e9a",
  null
  
)

export default component.exports